import { render, staticRenderFns } from "./EventPerdatin.vue?vue&type=template&id=b6dab320"
import script from "./EventPerdatin.vue?vue&type=script&lang=js"
export * from "./EventPerdatin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports